var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"last"},[_c('div',{staticClass:"container"},[_c('span',[_vm._v("2013-2019 "+_vm._s(_vm.siteName)+" 版权所有 |"),_c('a',{attrs:{"href":"http://beian.miit.gov.cn"}},[_vm._v(" "+_vm._s(_vm.icp)+" ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56136121","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Last.vue
// module id = null
// module chunks = 